module.exports = __webpack_public_path__ + "static/media/inter.d3103156.gif";